import { AxiosError } from 'axios';

export function extractErrorMessage(error: unknown, customeMessage?: string): string {
  const axiosErrorMessage = (error as AxiosError<any, any>)?.response?.data?.message?.message;

  if (error instanceof AxiosError && axiosErrorMessage) {
    return axiosErrorMessage;
  } else if (customeMessage) {
    return customeMessage;
  }

  return 'Something went wrong. Please try again later.';
}
